import { render, staticRenderFns } from "./KidsAppReviewRequestList.vue?vue&type=template&id=14197b5a&scoped=true"
import script from "./KidsAppReviewRequestList.vue?vue&type=script&lang=js"
export * from "./KidsAppReviewRequestList.vue?vue&type=script&lang=js"
import style0 from "./KidsAppReviewRequestList.vue?vue&type=style&index=0&id=14197b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14197b5a",
  null
  
)

export default component.exports